import { addNavMenuItem } from "@bb-vendure/admin-ui/core";

export default [
    addNavMenuItem({
        id: 'album-rank',
        label: 'nav.album-rank',
        routerLink: ['/extensions/album-rank'],
        icon: "block",
      },
      "marketing"
    ),
];
